import { appConfig } from "@/config/app.config";
import type { BrandLogoProps } from "@/types/components";

export function BrandLogo({ showWordmark = true, className = "" }: BrandLogoProps) {
  return (
    <span className={`inline-flex min-w-0 items-center gap-2 ${className}`}>
      <svg
        viewBox="0 0 64 64"
        className="h-8 w-8 flex-none"
        role={showWordmark ? "presentation" : "img"}
        aria-hidden={showWordmark ? true : undefined}
        aria-label={showWordmark ? undefined : `${appConfig.name} logo mark`}
      >
        <rect width="64" height="64" rx="10" className="fill-neutral-950 dark:fill-white" />
        <path
          d="M19 20h26a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H19a5 5 0 0 1-5-5V25a5 5 0 0 1 5-5Z"
          className="fill-white dark:fill-neutral-950"
        />
        <path d="m29 27 10 5-10 5V27Z" className="fill-neutral-950 dark:fill-white" />
        <path
          d="M17 50h30"
          strokeWidth="4"
          strokeLinecap="round"
          className="stroke-white dark:stroke-neutral-950"
        />
      </svg>
      {showWordmark ? <span className="truncate font-semibold">{appConfig.name}</span> : null}
    </span>
  );
}
